var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-879 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(879 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(847.64 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.958,8.882h-.6V6a.418.418,0,0,0-.005-.054.478.478,0,0,0-.116-.315L46.454.167l0,0a.479.479,0,0,0-.1-.081L46.321.063a.508.508,0,0,0-.1-.04L46.2.014A.484.484,0,0,0,46.087,0H34.322a.975.975,0,0,0-.974.974V8.881h-.6a1.392,1.392,0,0,0-1.392,1.392V17.51A1.392,1.392,0,0,0,32.752,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.388a.975.975,0,0,0,.974-.974V18.9h.6A1.392,1.392,0,0,0,53.35,17.51V10.273A1.392,1.392,0,0,0,51.958,8.882ZM34.322.974H45.6V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.322Zm10.26,9.154V17.4H42.931v-7.27Zm-8.016,1.359V10.128H41.84v.95L38.453,16v.043h3.441V17.4H36.242v-.885L39.7,11.53v-.043ZM50.388,23.593H34.322V18.9H50.388v4.691Zm.169-9.527a3.37,3.37,0,0,1-2.362.765,4.122,4.122,0,0,1-.561-.032v2.6H46.006V10.225a13.408,13.408,0,0,1,2.222-.151,3.488,3.488,0,0,1,2.223.582,2.126,2.126,0,0,1,.776,1.683A2.324,2.324,0,0,1,50.558,14.065Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M391.4,249.838a2.782,2.782,0,0,0-.68.065v2.146a2.512,2.512,0,0,0,.55.043c.873,0,1.413-.443,1.413-1.187C392.687,250.237,392.224,249.838,391.4,249.838Z",
    transform: "translate(-343.09 -238.524)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.a8385d89f1da815bedabd04f4a990cc7.svg";
export { ForwardRef as ReactComponent };